<template>
	<select @change='change' v-model="selected" class='form-control my-control' disabled>
		<option v-for="option in options" :value='option.id'>
			{{ option.name }}
		</option>
	</select>
</template>

<script>
	import {DB} from './../../../constants'
	const ORGANIZATION = 'get_organization.php'
	const HEADER = 'get_header.php'

	import {EventBus} from '../../../lib/EventBus'

	export default {
		name: 'organization',
		data: function () { 
			return {
				selected: '0',
				options: []
			}
		},
		props: {
			set_id: ''
		},
		methods: {
			change () {
				EventBus.$emit(`organization`, this.selected)
			}
		},
		created () {
			fetch(DB + HEADER + '?id=' + this.$parent.selected_act, {
				credentials: 'include'
			})
			.then(res => res.json())
			.then(res => {
				return res[0].f_11
			})
			.then((id) => {
				fetch(DB + ORGANIZATION, {
					credentials: 'include'
				})
				.then(data => data.json())
				.then(data => {
					if (data) {
						this.options = [{id: '0', name: ''}, ...data]; 
						this.selected = id
					}
					else {
						this.options = []
					}
				})
				.catch(err => console.log(err))
			})
			.catch(err => console.log(err))
		},
	}
</script>


// WEBPACK FOOTER //
// organization.vue?13e444ee